// extracted by mini-css-extract-plugin
export default {"link":"logotype_link__r-Qql","image":"logotype_image__YbXmZ"};